import { useEffect } from "react";
import {
  AddressInput,
  EmailField,
  InputText,
  PhoneNumberField,
} from "../../components";
import { useFormContext } from "react-hook-form";
import { connect } from "react-redux";
import { RootState } from "../../store/root-reducer";
import { classNames } from "../../helper";
import { PiCheckBold } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import { AddressDetails } from "../../components/AddressInput";

function UpdateContactInfo({ customer_data }) {
  const { control, reset, getValues, register, watch, setValue } =
    useFormContext();
  const allowSNSChecked = watch("customerInfo.allowSMS");
  const { t } = useTranslation();

  useEffect(() => {
    const values = getValues();
    values.customerInfo = {
      email: values?.customerInfo?.email || customer_data?.email || "",
      phone: values?.customerInfo?.phone || customer_data?.phone || "",
      address1: values?.customerInfo?.address1 || customer_data?.address1 || "",
      address2: values?.customerInfo?.address2 || customer_data?.address2 || "",
      city: values?.customerInfo?.city || customer_data?.city || "",
      state: values?.customerInfo?.state || customer_data?.state || "",
      zip: values?.customerInfo?.zip || customer_data?.zip || "",
      allowSMS: true,
    };
    reset(values);
    return () => {};
  }, [customer_data, getValues, reset]);

  return (
    <div className="mb-8 space-y-3">
      <EmailField
        control={control}
        name={"customerInfo.email"}
        label="Email"
        required
      />
      <PhoneNumberField
        control={control}
        name="customerInfo.phone"
        label="Phone number"
        required
        // defaultValue={customer_data?.phone}
      />
      <label className="flex flex-row  select-none items-center">
        <input
          type="checkbox"
          className="hidden"
          {...register("customerInfo.allowSMS")}
        />
        <div
          className={classNames(
            allowSNSChecked ? "border-[#2D6CCA] " : " border-[#DFDFDF]",
            "h-4 m-1 w-4 shrink-0 cursor-pointer bg-white rounded border flex items-center justify-center transition-all"
          )}
          aria-hidden="true"
        >
          {allowSNSChecked && <PiCheckBold className="size-3 text-[#2D6CCA]" />}
        </div>
        <span className="text-sm tracking-tight ms-0.5">
          {t(
            "I would like to receive claim updates via SMS messages. Opt-out anytime."
          )}
        </span>
      </label>
      <p className="text-gray-700 text-base font-semibold">
        {t("Furniture Location Address.")}
      </p>
      <div className="px-0.5 space-y-2">
        <AddressInput
          control={control}
          name="customerInfo.address1"
          onAddressSelect={(address: AddressDetails) => {
            setValue("customerInfo.city", address.city);
            setValue("customerInfo.state", address.state);
            setValue("customerInfo.zip", address.zipCode);
          }}
          label="Address"
          required
        />
        <InputText
          label={"Address 2"}
          control={control}
          name={"customerInfo.address2"}
        />
        <InputText
          label={"City"}
          control={control}
          name={"customerInfo.city"}
          required
        />
        <InputText
          label={"State"}
          control={control}
          name={"customerInfo.state"}
          required
        />
        <InputText
          name="customerInfo.zip"
          placeholder="000000"
          inputProps={{
            inputMode: "numeric",
          }}
          label="Zip"
          control={control}
          required
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  customer_data: state?.ace2Claim?.customer_data || {},
});

export default connect(mapStateToProps)(UpdateContactInfo);
